import React from 'react';
import { connect } from 'react-redux';
import { withPrefix } from 'gatsby-link';
import * as lottie from 'lottie-web';

class LottieContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: props.options,
      play: props.play,
      pause: props.pause,
      stop: props.stop,
      direction: props.direction,
      speed: props.speed,
      loop: props.loop,
      playOnView: props.playOnView,
    };
    this.updateInstance = this.updateInstance.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      options: nextProps.options,
      play: nextProps.play,
      pause: nextProps.pause,
      stop: nextProps.stop,
      direction: nextProps.direction,
      speed: nextProps.speed,
      loop: nextProps.loop,
      playOnView: nextProps.playOnView,
    });
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.play !== this.state.play || nextProps.direction !== this.state.direction) {
      this.updateInstance();
    }
  }

  updateInstance() {
    this.instance.setDirection(this.state.direction);
    this.instance.setSpeed(this.state.speed);
  }

  render() {
    return (
      <span ref={(elm) => this.elm = elm } />
    );
  }

  componentDidMount() {
    this.instance = lottie.loadAnimation({
      container: this.elm,
      renderer: 'svg',
      autoplay: this.props.autoplay,
      path: this.props.iconUrl ? this.props.iconUrl : withPrefix(`/lottie/${this.props.icon}.json`),
      loop: this.props.loop,
      rendererSettings: {
        
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.play !== this.state.play) {
      this.instance.play();
    }
  }
}

LottieContainer.defaultProps = {
  speed: 1,
  direction: 1,
  autoplay: false,
};

const mapStateToProps = (state) => {
  return { }
};

const Lottie = connect(
  mapStateToProps,
)(LottieContainer);

export default Lottie;



// WEBPACK FOOTER //
// ./src/components/Lottie/index.jsx